module.exports = __webpack_public_path__ + "media/images/flags/16/United-Arab-Emirates-1ce117e34b891d296cf1a18fb18e996a.png";